export default __webpack_public_path__ + "static/media/vesko_avatar.ed163924.jpeg";